// 用户
import {
  LoginJWTToken,
  GetInfoByToken,
  GetNavigationBar,
  apiLoginLogOut,
  educationGet,
  degreeGet,
  DeployDistrictGet,
  PersonGetAllUsers,
  PersonPostUserInfo,
  identityresumePage,
  identityresumePost,
  identityresumePut,
  identityresumeDelete,
  PicUploadToRemote,
  UserAuditPost,
  QuitEnterprisePost,
  QuitEnterpriseQuery,
  UserAuditUserQuery,
  EnterpriseAuditSubmit,
  EnterpriseAuditQueryState,
  CourseUserQuery,
  CourseHourGet,
  AddUserFacePhoto,
  UserPhotoUserAuth,
  OwnCourseQuery,
  OwnPlanQuery,
  OwnCourseOwnPlanCourseQuery,
  OwnQuestionBankQuery,
  OwnSmlibraryQuery,
  OwnPaperOwnPlanPaperQuery,
  OwnPaperGetOwnPaperInfo,
  OwnPaperGetOwnPaperQuestion,
  OwnPaperCommitPaper,
  OwnPaperGetOwnPaperDrillQuestion,
  OwnCourseGetCourse,
  OwnCollectPost,
  OwnCollectDelete,
  GetValidateCode,
  LoginPhoneLogin,
  CourseCollectQuery,
  GetOwnLibQuestion,
  GetErrorQuestionDetailList,
  DeleteErrorQuestion,
  EvaluateQuery,
  EvaluatePost,
  OwnOrderQueryUserOrder,
  GetOwnIntegral,
  QueryIntegralOrigin,
  QuestionLibCollectQuery,
  QuestionLibraryUserQuery,
  GetQuestionLibrary,
  smlibraryUserGet,
  OwnSmlibraryGetSmlib,
  WeChatPayQrCodePay,
  GetOrderState,
  GetOutTradeNoPage,
  AlipayPcPay,
  OwnEveryDayTaskGetPaperInfo,
  GetCourseSet,
  IsLessonStudy,
  AddLesson,
  GetCourseHourByid,
  UserFaceAuth,
  SmlibCollectQuery,
  CommitRightOrErrorRecode,
  GetTodayState,
  OwnEveryDayTaskCommitPaper,
  OwnEveryDayTaskQuery,
  OwnEveryDayTaskGet,
  GetMonthState,
  OwnEveryMonthTaskGetPaperInfo,
  OwnEveryMonthTaskCommitPaper,
  OwnEveryMonthTaskQuery,
  OwnEveryMonthTaskGet,
  OwnEveryWeekTaskQuery,
  FreeAddCourse,
  GetCourseHourList,
  OwnQuestionBankFreeAddCourse,
  NewsGetNewsList,
  NoticeGetNewsList,
  FreeAddSoftware,
  UserGetSmfileList,
  OwnEveryWeekTaskStartStudy,
  PlanGetPlanFaceConfig,
  OwnQuestionBankSaveSchedule,
  LecturerGetLecturer,
  UserGetSoftwareList,
  StartSoftwareServer,
  GetSoftwareInfo,
  UpdateTaskProgross,
  OwnPaperSaveSchedule,
  CourseNoteQuery,
  CourseNotePost,
  CourseNoteDeleteNote,
  OwnPlanCoursePaperList,
  OwnCoursePaperGetPracticeQuestion,
  OwnCoursePaperSaveSchedule,
  OwnCoursePaperGetPaperQuestion,
  OwnCoursePaperCommitPaper,
  StatisticsGetMyData,
  EmployInfoPageList,
  AddEmployInfo,
  UpdateEmployInfo,
  DeleteEmployInfo,
  ResumeInfoPageList,
  AddResumeInfo,
  StaffActivityPageList,
  AddStaffActivity,
  DeleteStaffActivity,
  DeleteResumeInfo,
  GetTrainClassify,
  TrainClassifyGetChildrenList,
  GetPaperRecordList,
  GetPaperQuestionRecord,
} from "./user";
// 管理
import {
  GetTreeTable,
  GetPermissionTree,
  GetApiList,
  PermissionPost,
  PermissionPut,
  PermissionDelete,
  ModuleGet,
  ModulePost,
  ModulePut,
  ModuleDelete,
  RoleGet,
  RolePost,
  RolePut,
  RoleDelete,
  GetPermissionIdByRoleId,
  PermissionAssign,
  GetRootNavigationBar,
  GetNavigationBarByPid,
  MonitorQuery,
  OnlineQuery,
  OnlineDelete,
  GetTaskNameSpace,
  TasksQzPost,
  TasksQzGet,
  TasksQzPut,
  TasksQzStartJob,
  TasksQzStopJob,
  TasksQzDelete,
  UserGetAddmin,
  SensitiveWordsQueryBlackIp,
  AddSensitiveWords,
  UpdateSensitiveWords,
  DeleteSensitiveWords,
  QueryBlackIp,
  AddBlackIp,
  UpdateBlackIp,
  DeleteBlackIp,
  UserPostAdmin,
  CClassifyQuery,
  CClassifyControlState,
  CClassifyPost,
  CClassifyPut,
  CClassifyDelete,
  CSSubjectQuery,
  CSSubjectControlState,
  CSSubjectPost,
  CSSubjectPut,
  CSSubjectDelete,
  IndustryClassifyQuery,
  IndustryClassifyControlState,
  IndustryClassifyPost,
  IndustryClassifyPut,
  IndustryClassifyDelete,
  UserPut,
  UserDelete,
  UpdatePwd,
  GetEnterprise,
  GetUserPhotoData,
  PutEnterprise,
  SuperGetAllUsers,
  QueryInstitution,
  SMClassifyQuery,
  SMClassifyControlState,
  SMClassifyPost,
  SMClassifyPut,
  SMClassifyDelete,
  QuestionClassifyQuery,
  QuestionClassifyControlState,
  QuestionClassifyPost,
  QuestionClassifyPut,
  QuestionClassifyDelete,
  PaperClassifyQuery,
  PaperClassifyControlState,
  PaperClassifyPost,
  PaperClassifyPut,
  PaperClassifyDelete,
  PlanClassifyQuery,
  PlanClassifyControlState,
  PlanClassifyPost,
  PlanClassifyPut,
  PlanClassifyDelete,
  EntepriseClassifyQuery,
  EntepriseClassifyControlState,
  EntepriseClassifyPost,
  EntepriseClassifyPut,
  EntepriseClassifyDelete,
  TrainClassifyQuery,
  TrainClassifyPost,
  TrainClassifyPut,
  TrainClassifyDelete,
  ConstrolState,
  DepartmentGetTreeTable,
  DepartmentPost,
  DepartmentPut,
  DepartmentDelete,
  AppointmentQuery,
  AppointmentPost,
  AppointmentPut,
  AppointmentDelete,
  EntGetAllUsers,
  GetDepartmentTree,
  UserPost,
  EntPostUserInfo,
  DeleteEnterprise,
  smlibraryGet,
  smlibraryGetById,
  smlibraryPost,
  smlibraryPublishState,
  smlibraryPut,
  smlibraryDelete,
  UserAuditAdminQuery,
  UserAuditAudit,
  EnterpriseAuditQuery,
  EnterpriseAuditAudit,
  smfilepackEntGet,
  ExportUserTemplate,
  UploadUsers,
  TYYCreatVideo,
  CreatTransCodeTask,
  GetTransCodeVideoUrl,
  queryTaskProcess,
  GetS3TaskProcess,
  smfilepackPost,
  smfilepackDelete,
  smfilepackPut,
  UploadFileToRemote,
  QuestionLibraryPost,
  QuestionLibraryQuery,
  QuestionLibraryChangePublishState,
  QuestionLibraryPut,
  QuestionLibraryDelete,
  QuestionLibraryGet,
  SetLibPaperSet,
  GetLibPaperSet,
  QuestionQuery,
  QuestionPost,
  ExportQuestionTemplate,
  UploadQuestion,
  QuestionPut,
  QuestionDelete,
  DelLibraryAllQuestion,
  QuestionGet,
  PaperQuery,
  PaperPost,
  PaperGet,
  PaperPut,
  PaperDelete,
  PaperUpdatePublishState,
  RandomAddQuestions,
  PaperQuestionQuery,
  BatchAddQuestions,
  PaperQuestionDelete,
  PaperAddLibrary,
  CoursePost,
  CourseQuery,
  CourseDelete,
  CourseUpdatePublishState,
  CourseGet,
  CoursePut,
  CatalogueGet,
  CatalogueQueryTree,
  GetCourseCatalogue,
  CataloguePost,
  CataloguePut,
  CatalogueDelete,
  CourseHourBatchAdd,
  smfilepackCourseGet,
  smlibraryAdminGet,
  CourseHourDelete,
  CourseFilePost,
  CourseFileQuery,
  CourseFilePut,
  CourseFileDelete,
  PlanPost,
  PlanQuery,
  GetPlanUserList,
  GetPlanUserListNoCheck,
  PlanBatchAddUser,
  PlanGet,
  PlanDelete,
  PlanPut,
  CopyPlan,
  GetCourseListNoCheck,
  PlanAndCourseAddCourseList,
  PlanAndCourseQueryCourseList,
  PlanAndCoursePagerUserQuery,
  PlanAndCourseDelete,
  PlanChangePublishState,
  PlanAndPaperQueryCourseList,
  PlanAndPaperPagerUserQuery,
  PlanAndPaperGetPaperListNoCheck,
  PlanAndPaperAddCourseList,
  PlanAndPaperDelete,
  OperateQuery,
  PostAuthQuestionBank,
  GetUserList,
  GetEnterpriseList,
  CourseOperateQuery,
  AuthCourseGetUserList,
  AuthCourseGetEnterpriseList,
  AuthCoursePost,
  smlibraryOperateGet,
  AuthSmlibraryGetUserList,
  AuthSmlibraryGetEnterpriseList,
  AuthSmlibraryPost,
  CourseOperateUpdateOnlineState,
  CourseOperateRecommendState,
  CourseOperateBoutiqueState,
  BankOnlineState,
  SmlibraryOnSmLib,
  smlibrarySetBoutiqueState,
  smlibrarySetRecommendState,
  AdminOrderQuery,
  EveryDayTaskQuery,
  EveryDayTaskPost,
  EveryDayTaskPut,
  EveryDayTaskDelete,
  EveryWeekTaskPost,
  EveryWeekTaskQuery,
  EveryWeekTaskPut,
  EveryWeekTaskDelete,
  EveryMonthTaskQuery,
  EveryMonthTaskPost,
  EveryMonthTaskPut,
  EveryMonthTaskDelete,
  PhysicalSpaceQuery,
  PhysicalSpacePost,
  PhysicalSpacePut,
  PhysicalSpaceDelete,
  QueryAllRegion,
  PhyRegionGetAllCamera,
  PhysicalSpaceGetPhysicsLogin,
  PhyRegionPost,
  PhyRegionPut,
  PhyRegionDelete,
  GetNoUseRegionList,
  PlanPhyRegionPost,
  PlanPhyRegionQuery,
  PlanPhyRegionDelete,
  GetNoUseDeivceList,
  PlanPhyDeviceQuery,
  PlanPhyDevicePost,
  PlanPhyDeviceDelete,
  AdminGetUserCourseQuery,
  IntegralOriginAdminQuery,
  AdminCollectQuery,
  SoftwareQuery,
  SoftwarePost,
  SoftwarePut,
  SoftwareDelete,
  SoftwareGet,
  workingconditionQuery,
  workingconditionPost,
  workingconditionPut,
  workingconditionDelete,
  SoftwarePublishState,
  SoftwareOnlineState,
  SoftwareOperateQuery,
  SoftwareOperateBoutiqueState,
  SoftwareOperateRecommendState,
  AuthSoftwarePost,
  NewsQuery,
  NewsChangePublishState,
  NewsChangeTopState,
  NewsPost,
  NewsPut,
  NewsDelete,
  NoticeQuery,
  NoticePost,
  NoticePut,
  NoticeDelete,
  NoticeChangePublishState,
  AuthSoftwareGetEnterpriseList,
  AuthSoftwareGetUserList,
  ImgSoftwareUpload,
  AdvertisementQuery,
  QuestionLibrarySetBoutiqueState,
  QuestionLibrarySetRecommendState,
  LecturerQuery,
  LecturerGet,
  LecturerPost,
  LecturerDelete,
  LecturerPut,
  UserAdminGetRoleUser,
  PlanUploadUsers,
  EnterpriseQueryAll,
  UserSuperPostUser,
  UserSuperPostEnterpriseUser,
  GetPlanCourseChList,
  LecturerQueryAll,
  UpdatePlanCourse,
  EntChangeTeacherRole,
  OwnPlanAdminQuery,
  PlanGetExportPlanData,
  GetCCStatistics,
  GetPlantatistics,
  GetTrainTypeStatistics,
  GetUserMonthAddedStatistics,
  GetUserStatistics,
  UserAdminUpdateUserPwd,
  PlanDelPlanUser,
  StatisticsGetUserStatistics,
  StatisticsGetUserMonthAddedStatistics,
  StatisticsGetTrainTypeStatistics,
  StatisticsGetCCStatistics,
  StatisticsGetPlantatistics,
  DepartmentDepartmentImportUsers,
  ExportCatalogueTemplate,
  CatalogueImportCatalogue,
  IndustryClassifyGetListByCsId,
  PaperQueryAll,
  QuestionLibraryQueryAll,
  GetPlanPaperRecordList,
  GetPlanUserProve,
  StatisticsGetOfflinePhySpaceData,
  StatisticsGetEnterpriseStatisData,
  PushPlanToTrainPlatfom,
} from "./admin"

export default {
  LoginJWTToken,
  GetInfoByToken,
  GetNavigationBar,
  apiLoginLogOut,
  educationGet,
  degreeGet,
  DeployDistrictGet,
  PersonGetAllUsers,
  PersonPostUserInfo,
  identityresumePage,
  identityresumePost,
  identityresumePut,
  identityresumeDelete,
  PicUploadToRemote,
  UserAuditPost,
  QuitEnterprisePost,
  QuitEnterpriseQuery,
  UserAuditUserQuery,
  EnterpriseAuditSubmit,
  EnterpriseAuditQueryState,
  CourseUserQuery,
  CourseHourGet,
  AddUserFacePhoto,
  UserPhotoUserAuth,
  OwnCourseQuery,
  OwnPlanQuery,
  OwnCourseOwnPlanCourseQuery,
  OwnQuestionBankQuery,
  OwnSmlibraryQuery,
  OwnPaperOwnPlanPaperQuery,
  OwnPaperGetOwnPaperInfo,
  OwnPaperGetOwnPaperQuestion,
  OwnPaperCommitPaper,
  OwnPaperGetOwnPaperDrillQuestion,
  OwnCourseGetCourse,
  OwnCollectPost,
  OwnCollectDelete,
  GetValidateCode,
  LoginPhoneLogin,
  CourseCollectQuery,
  GetOwnLibQuestion,
  EvaluateQuery,
  EvaluatePost,
  OwnOrderQueryUserOrder,
  GetOwnIntegral,
  QueryIntegralOrigin,
  QuestionLibCollectQuery,
  QuestionLibraryUserQuery,
  GetQuestionLibrary,
  smlibraryUserGet,
  OwnSmlibraryGetSmlib,
  WeChatPayQrCodePay,
  GetOrderState,
  GetOutTradeNoPage,
  AlipayPcPay,
  OwnEveryDayTaskGetPaperInfo,
  GetCourseSet,
  IsLessonStudy,
  AddLesson,
  GetCourseHourByid,
  UserFaceAuth,
  SmlibCollectQuery,
  CommitRightOrErrorRecode,
  GetTodayState,
  OwnEveryDayTaskCommitPaper,
  OwnEveryDayTaskQuery,
  OwnEveryDayTaskGet,
  GetMonthState,
  OwnEveryMonthTaskGetPaperInfo,
  OwnEveryMonthTaskCommitPaper,
  OwnEveryMonthTaskQuery,
  OwnEveryMonthTaskGet,
  OwnEveryWeekTaskQuery,
  FreeAddCourse,
  GetCourseHourList,
  OwnQuestionBankFreeAddCourse,
  NewsGetNewsList,
  NoticeGetNewsList,
  FreeAddSoftware,
  UserGetSmfileList,
  OwnEveryWeekTaskStartStudy,
  PlanGetPlanFaceConfig,
  OwnQuestionBankSaveSchedule,
  UserGetSoftwareList,
  StartSoftwareServer,
  GetSoftwareInfo,
  UpdateTaskProgross,
  OwnPaperSaveSchedule,
  CourseNoteQuery,
  CourseNotePost,
  CourseNoteDeleteNote,
  OwnPlanCoursePaperList,
  OwnCoursePaperGetPracticeQuestion,
  OwnCoursePaperSaveSchedule,
  OwnCoursePaperGetPaperQuestion,
  OwnCoursePaperCommitPaper,
  StatisticsGetMyData,
  EmployInfoPageList,
  AddEmployInfo,
  UpdateEmployInfo,
  DeleteEmployInfo,
  ResumeInfoPageList,
  AddResumeInfo,
  StaffActivityPageList,
  AddStaffActivity,
  DeleteStaffActivity,
  DeleteResumeInfo,
  GetTrainClassify,
  TrainClassifyGetChildrenList,
  GetPaperRecordList,
  GetPaperQuestionRecord,
  // 管理
  GetTreeTable,
  GetPermissionTree,
  GetApiList,
  PermissionPost,
  PermissionPut,
  PermissionDelete,
  ModuleGet,
  ModulePost,
  ModulePut,
  ModuleDelete,
  RoleGet,
  RolePost,
  RolePut,
  RoleDelete,
  GetPermissionIdByRoleId,
  PermissionAssign,
  GetRootNavigationBar,
  GetNavigationBarByPid,
  MonitorQuery,
  OnlineQuery,
  OnlineDelete,
  GetTaskNameSpace,
  TasksQzPost,
  TasksQzGet,
  TasksQzPut,
  TasksQzStartJob,
  TasksQzStopJob,
  TasksQzDelete,
  UserGetAddmin,
  SensitiveWordsQueryBlackIp,
  AddSensitiveWords,
  UpdateSensitiveWords,
  DeleteSensitiveWords,
  QueryBlackIp,
  AddBlackIp,
  UpdateBlackIp,
  DeleteBlackIp,
  UserPostAdmin,
  CClassifyQuery,
  CClassifyControlState,
  CClassifyPost,
  CClassifyPut,
  CClassifyDelete,
  CSSubjectQuery,
  CSSubjectControlState,
  CSSubjectPost,
  CSSubjectPut,
  CSSubjectDelete,
  IndustryClassifyQuery,
  IndustryClassifyControlState,
  IndustryClassifyPost,
  IndustryClassifyPut,
  IndustryClassifyDelete,
  UserPut,
  UserDelete,
  UpdatePwd,
  GetEnterprise,
  PutEnterprise,
  QueryInstitution,
  SMClassifyQuery,
  SMClassifyControlState,
  SMClassifyPost,
  SMClassifyPut,
  SMClassifyDelete,
  QuestionClassifyQuery,
  QuestionClassifyControlState,
  QuestionClassifyPost,
  QuestionClassifyPut,
  QuestionClassifyDelete,
  PaperClassifyQuery,
  PaperClassifyControlState,
  PaperClassifyPost,
  PaperClassifyPut,
  PaperClassifyDelete,
  PlanClassifyQuery,
  PlanClassifyControlState,
  PlanClassifyPost,
  PlanClassifyPut,
  PlanClassifyDelete,
  EntepriseClassifyQuery,
  EntepriseClassifyControlState,
  EntepriseClassifyPost,
  EntepriseClassifyPut,
  EntepriseClassifyDelete,
  TrainClassifyQuery,
  TrainClassifyPost,
  TrainClassifyPut,
  TrainClassifyDelete,
  ConstrolState,
  DepartmentGetTreeTable,
  DepartmentPost,
  DepartmentPut,
  DepartmentDelete,
  AppointmentQuery,
  AppointmentPost,
  AppointmentPut,
  AppointmentDelete,
  EntGetAllUsers,
  GetDepartmentTree,
  UserPost,
  EntPostUserInfo,
  DeleteEnterprise,
  smlibraryGet,
  smlibraryGetById,
  smlibraryPost,
  smlibraryPublishState,
  smlibraryPut,
  smlibraryDelete,
  UserAuditAdminQuery,
  UserAuditAudit,
  EnterpriseAuditQuery,
  EnterpriseAuditAudit,
  SuperGetAllUsers,
  smfilepackEntGet,
  ExportUserTemplate,
  UploadUsers,
  TYYCreatVideo,
  CreatTransCodeTask,
  GetTransCodeVideoUrl,
  queryTaskProcess,
  GetS3TaskProcess,
  smfilepackPost,
  smfilepackDelete,
  smfilepackPut,
  UploadFileToRemote,
  QuestionLibraryPost,
  QuestionLibraryQuery,
  QuestionLibraryChangePublishState,
  QuestionLibraryPut,
  QuestionLibraryDelete,
  QuestionLibraryGet,
  SetLibPaperSet,
  GetLibPaperSet,
  QuestionQuery,
  QuestionPost,
  ExportQuestionTemplate,
  UploadQuestion,
  QuestionPut,
  QuestionDelete,
  DelLibraryAllQuestion,
  QuestionGet,
  PaperQuery,
  PaperPost,
  PaperGet,
  PaperPut,
  PaperDelete,
  PaperUpdatePublishState,
  RandomAddQuestions,
  PaperQuestionQuery,
  BatchAddQuestions,
  PaperQuestionDelete,
  PaperAddLibrary,
  CoursePost,
  CourseQuery,
  CourseDelete,
  CourseUpdatePublishState,
  CourseGet,
  CoursePut,
  CatalogueGet,
  CatalogueQueryTree,
  GetCourseCatalogue,
  CataloguePost,
  CataloguePut,
  CatalogueDelete,
  GetUserPhotoData,
  CourseHourBatchAdd,
  smfilepackCourseGet,
  smlibraryAdminGet,
  CourseHourDelete,
  CourseFilePost,
  CourseFileQuery,
  CourseFilePut,
  CourseFileDelete,
  PlanPost,
  PlanQuery,
  GetPlanUserList,
  GetPlanUserListNoCheck,
  PlanBatchAddUser,
  PlanGet,
  PlanDelete,
  PlanPut,
  CopyPlan,
  GetCourseListNoCheck,
  PlanAndCourseAddCourseList,
  PlanAndCourseQueryCourseList,
  PlanAndCoursePagerUserQuery,
  PlanAndCourseDelete,
  PlanChangePublishState,
  PlanAndPaperQueryCourseList,
  PlanAndPaperPagerUserQuery,
  PlanAndPaperGetPaperListNoCheck,
  PlanAndPaperAddCourseList,
  PlanAndPaperDelete,
  OperateQuery,
  PostAuthQuestionBank,
  GetUserList,
  GetEnterpriseList,
  CourseOperateQuery,
  AuthCourseGetUserList,
  AuthCourseGetEnterpriseList,
  AuthCoursePost,
  smlibraryOperateGet,
  AuthSmlibraryGetUserList,
  AuthSmlibraryGetEnterpriseList,
  AuthSmlibraryPost,
  CourseOperateUpdateOnlineState,
  CourseOperateRecommendState,
  CourseOperateBoutiqueState,
  BankOnlineState,
  SmlibraryOnSmLib,
  smlibrarySetBoutiqueState,
  smlibrarySetRecommendState,
  CourseCollectQuery,
  GetErrorQuestionDetailList,
  DeleteErrorQuestion,
  AdminOrderQuery,
  EveryDayTaskQuery,
  EveryDayTaskPost,
  EveryDayTaskPut,
  EveryDayTaskDelete,
  EveryWeekTaskPost,
  EveryWeekTaskQuery,
  EveryWeekTaskPut,
  EveryWeekTaskDelete,
  EveryMonthTaskQuery,
  EveryMonthTaskPost,
  EveryMonthTaskPut,
  EveryMonthTaskDelete,
  PhysicalSpaceQuery,
  PhysicalSpacePost,
  PhysicalSpacePut,
  PhysicalSpaceDelete,
  QueryAllRegion,
  PhyRegionGetAllCamera,
  PhysicalSpaceGetPhysicsLogin,
  PhyRegionPost,
  PhyRegionPut,
  PhyRegionDelete,
  GetNoUseRegionList,
  PlanPhyRegionPost,
  PlanPhyRegionQuery,
  PlanPhyRegionDelete,
  GetNoUseDeivceList,
  PlanPhyDeviceQuery,
  PlanPhyDevicePost,
  PlanPhyDeviceDelete,
  AdminGetUserCourseQuery,
  IntegralOriginAdminQuery,
  AdminCollectQuery,
  SoftwareQuery,
  SoftwarePost,
  SoftwarePut,
  SoftwareDelete,
  SoftwareGet,
  workingconditionQuery,
  workingconditionPost,
  workingconditionPut,
  workingconditionDelete,
  SoftwarePublishState,
  SoftwareOnlineState,
  SoftwareOperateQuery,
  SoftwareOperateBoutiqueState,
  SoftwareOperateRecommendState,
  AuthSoftwarePost,
  NewsQuery,
  NewsChangePublishState,
  NewsChangeTopState,
  NewsPost,
  NewsPut,
  NewsDelete,
  NoticeQuery,
  NoticePost,
  NoticePut,
  NoticeDelete,
  NoticeChangePublishState,
  AuthSoftwareGetEnterpriseList,
  AuthSoftwareGetUserList,
  ImgSoftwareUpload,
  AdvertisementQuery,
  QuestionLibrarySetBoutiqueState,
  QuestionLibrarySetRecommendState,
  LecturerQuery,
  LecturerGet,
  LecturerPost,
  LecturerDelete,
  LecturerPut,
  UserAdminGetRoleUser,
  PlanUploadUsers,
  EnterpriseQueryAll,
  UserSuperPostUser,
  UserSuperPostEnterpriseUser,
  GetPlanCourseChList,
  LecturerQueryAll,
  UpdatePlanCourse,
  LecturerGetLecturer,
  EntChangeTeacherRole,
  OwnPlanAdminQuery,
  PlanGetExportPlanData,
  GetCCStatistics,
  GetPlantatistics,
  GetTrainTypeStatistics,
  GetUserMonthAddedStatistics,
  GetUserStatistics,
  UserAdminUpdateUserPwd,
  PlanDelPlanUser,
  StatisticsGetUserStatistics,
  StatisticsGetUserMonthAddedStatistics,
  StatisticsGetTrainTypeStatistics,
  StatisticsGetCCStatistics,
  StatisticsGetPlantatistics,
  DepartmentDepartmentImportUsers,
  ExportCatalogueTemplate,
  CatalogueImportCatalogue,
  IndustryClassifyGetListByCsId,
  PaperQueryAll,
  QuestionLibraryQueryAll,
  GetPlanPaperRecordList,
  GetPlanUserProve,
  StatisticsGetOfflinePhySpaceData,
   StatisticsGetEnterpriseStatisData,
   PushPlanToTrainPlatfom,
};
